<style>
  ._3stt ._3sts {
    padding-top: 8px;
  }

  ._3sts {
    color: #666;
    font-weight: bold;
    padding-right: 10px;
    text-align: right;
    width: 130px;
    word-wrap: break-word;
  }

  ._480u,
  ._480v,
  ._3sts {
    padding: 3px 0 1px 0;
    text-align: left;
    /*vertical-align: top;*/
  }

  ._3stn {
    /* border: 0; */
    border-collapse: collapse;
    /* border-spacing: 0; */
    /* table-layout: fixed; */
    /* width: 100%; */
  }
  /*tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}*/
</style>
<form [formGroup]="form" class="form-horizontal" style="padding-top: 200px">
  <div
    class="mvl ptm uiInterstitial uiInterstitialLarge uiBoxWhite"
    style="
      margin: auto;
      width: 50%;
      padding: 20px;
      background-color: white;
      height: auto;
    "
    checked
  >
    <div
      class="uiHeader uiHeaderBottomBorder mhl mts uiHeaderPage interstitialHeader"
    >
      <div class="clearfix uiHeaderTop">
        <div class="rfloat _ohf">
          <div class="uiHeaderActions"></div>
        </div>
        <div
          style="
            padding: 5px;
            border-bottom: solid 1px #dcdcdc;
            margin-bottom: 10px;
          "
        >
          <h2 class="uiHeaderTitle" aria-hidden="true">
            Choose a new password
          </h2>
        </div>
      </div>
    </div>
    <div class="phl ptm uiInterstitialContent">
      <div class="identify_yourself_block">
        <table>
          <tbody>
            <tr>
              <td></td>
              <td>
                <div>
                  A strong password is a combination of letters and punctuation
                  marks. It must be at least 6 characters long.
                </div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td>
                <tr class="_41sx _3stt">
                  <th class="_3sts">
                    <label for="password_new">New Password</label>
                  </th>
                  <td class="_480u">
                    <input
                      type="password"
                      class="inputtext _55r1 _41sy"
                      id="password_new"
                      name="password_new"
                      tabindex="1"
                      autocomplete="off"
                      aria-describedby="password_new_status"
                      formControlName="NewPwd"
                      style="margin-top: 14px"
                    />
                    <div id="password_new_status">
                      <span class="accessible_elem">
                        &nbsp;
                        <!--&nbsp;&nbsp;for strong password-->
                      </span>
                    </div>
                  </td>
                </tr>
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div
      style="padding: 20px; border-top: solid 1px #f4ecec; margin-bottom: 10px"
    >
      <button
        class="rfloat _ohf"
        type="button"
        title="Save"
        style="background-color: white; color: black; border: 2px solid #dcdcdc"
        (click)="Cancel()"
      >
        Cancel
      </button>
      <button
        class="rfloat _ohf"
        type="button"
        title="Save"
        style="
          background-color: white;
          color: black;
          border: 2px solid #4caf50;
          margin-right: 5px;
        "
        (click)="confirmPassword()"
        [disabled]="!form.valid"
      >
        Continue
      </button>
    </div>
  </div>
</form>
<div
  class="modal fade"
  bsModal
  #childModal="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-header">
        <button class="close" aria-label="Close" (click)="hideChildModal()">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title" style="border-bottom: solid 1px #dcdcdc">
          Information
        </h4>
      </div>
      <div class="modal-body">
        {{ DialogMessage }}
      </div>
    </div>
  </div>
</div>
